import React from "react";
import Mdx from "../content/shaving-your-head-while-traveling.md";
import { BlogPostTemplate } from "finx/lib/react-static/post/BlogPostTemplate";
import { withRouteData } from "react-static";
import { PostsPath } from "finx/lib/site/travel/pages/posts/Posts";

export default withRouteData(props => {
  return (
    <BlogPostTemplate {...props} postsPath={PostsPath}>
      <Mdx {...props.fetchedData} />
    </BlogPostTemplate>
  );
});
